import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class StockTransferListStyle extends CommonComponentStyle {
  SKUGridWrapper = styled(Grid)`
    padding: 8px 0;
  `;

  SKUGrid = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
    padding-top: 8px;
  `;

  SKUButtonGrid = styled(Grid)`
    text-align: right;
  `;

  TableInfoGridWrapper = styled(Grid)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  `;

  TableInfoGrid = styled(Grid)`
    padding: 8px 0;
  `;

  ProgressSpan = styled.span`
    color: ${this.colors.PRIMARY_GRAY};
    margin-left: 8px;
  `;
}

export const stockTransferListStyle = new StockTransferListStyle();
